import React from 'react';

import ChoiceGroup from '../form-wrappers/choice-group';

import ByMonthDayAndIntervalChoice from '../complex-form-choices/by-month-day-and-interval-choice';
import BySetPositionAndByDayAndIntervalChoice from '../complex-form-choices/by-set-position-and-by-day-and-interval-choice';

const MonthlyGroup = ({ onChangeGroup, requiredItems, selectedChoice, isRadioGroup, rootContainer }) => {
  const complexChoiceSizes = { span: 24, offset: 0, prefix: { span: 4, offset: 0 }, child: { span: 15, offset: 0 }, suffix: { span: 5, offset: 0 } };

  return (
    <ChoiceGroup
      itemObj={{
        isRadioGroup: isRadioGroup,
        onChange: onChangeGroup,
      }}
    >
      <ByMonthDayAndIntervalChoice
        requiredItems={requiredItems}
        selectedChoice={selectedChoice}
        isRadioGroup={isRadioGroup}
        rootContainer={rootContainer}
      />

      <BySetPositionAndByDayAndIntervalChoice
        requiredItems={requiredItems}
        selectedChoice={selectedChoice}
        isRadioGroup={isRadioGroup}
        rootContainer={rootContainer}
      />
    </ChoiceGroup>
  );
};
export default MonthlyGroup;
